import request from '@/utils/request'

const api = {
  workDirList: '/work/dir',
  createFolder: "/work/saveOrUpdate",
  softDelete: "/work/softDelete",
  queryRecycle: "/work/recycle",
  workDelete: "/work/deleteInfo",
  workRegain: "/work/regain",
  getTreeDir: "/work/getAllDir",
  getFolderDepth: "/work/getParentInfo",
  moveDir: "/work/moveDir",
  workList: '/work/list',
  workDir: '/work/dir',
  releaseWork: "/work/asyncList",
  deleteAsync: "/work/deleteAsync",
  iconAll: "/icon/all",
  workDetail: "/work/workDetail",
  workEdit: "/work/edit",
  updateBrowse:"/work/updateBrowse",
  getWork3DPayConfig:"/work/getWork3DPayConfig",
  addWork3D:"/work/addWork3D",
  visitCount: "/addVisit",
  recommend:"/work/recommend",
  queryWorkRecommend:"/queryWorkRecommend",
  queryAll:"/work/queryAll",
  queryAllRecycle:"/work/queryAllRecycle",
  roomDetail: "/takelookDetail",
  queryTalk: "/workComment/pageQuery",
  delTalk: "/workComment/deleteInfo",
  downloadSceneImgs: "/work/downloadImgs",
  queryTeamUser:"/team/getTeamUser",
  getDesignateList:"/team/getDesignateList",
  updDesignateList:"/team/updDesignateList",
  getWorkPanoCount: "/work/getWorkPanoCount",
  copyWork: "/work/copyWork",
}

export default api

export function downloadZip(url) {
  return request({
    url,
    method: 'post',
    responseType: "arraybuffer",
    // responseType: "blob",
  })
}

export function getSceneSources(data) {
  return request({
    url: api.downloadSceneImgs,
    method: 'post',
    data
  })
}

export function getRoomDetail(data) {
  return request({
    url: api.roomDetail,
    method: 'post',
    data
  })
}

export function addVisitCount(data) {
  return request({
    url: api.visitCount,
    method: 'post',
    data
  })
}

export function getWorkDetail(data) {
  return request({
    url: api.workDetail,
    method: 'post',
    data,
    showloading: true
  })
}

export function saveEditedWork(data) {
  return request({
    url: api.workEdit,
    method: 'post',
    data,
    showloading: true
  })
}

export function getWork3DPayConfig(data) {
  return request({
    url: api.getWork3DPayConfig,
    method: 'post',
    data,
    showloading: true
  })
}

export function addWork3D(data) {
  return request({
    url: api.addWork3D,
    method: 'post',
    data,
    showloading: true
  })
}

export function getAllIcons(data) {
  return request({
    url: api.iconAll,
    method: 'post',
    data
  })
}

export function getWorkList(data) {
  return request({
    url: api.workDirList,
    method: 'post',
    data
  })
}
export function createFolder(data) {
  return request({
    url: api.createFolder,
    method: 'post',
    data
  })
}

export function softDelete(data) {
  return request({
    url: api.softDelete,
    method: 'post',
    data
  })
}
export function queryRecycle(data) {
  return request({
    url: api.queryRecycle,
    method: 'post',
    data
  })
}

export function workDelete(data) {
  return request({
    url: api.workDelete,
    method: 'post',
    data
  })
}

export function workRegain(data) {
  return request({
    url: api.workRegain,
    method: 'post',
    data
  })
}

export function getTreeDir(data) {
  return request({
    url: api.getTreeDir,
    method: 'post',
    data
  })
}

export function getFolderDepth(data) {
  return request({
    url: api.getFolderDepth,
    method: 'post',
    data
  })
}

export function moveDir(data) {
  return request({
    url: api.moveDir, method: 'post',
    data
  })
}

export function getWorkDir(data) {
  return request({
    url: api.workDir,
    method: 'post',
    data
  })
}

export function releaseWork() {
  return request({
    url: api.releaseWork,
    method: 'post'
  })
}

export function deleteAsync(data) {
  return request({
    url: api.deleteAsync,
    method: 'post',
    data
  })
}

export function pageQueryWork(data) {
  return request({
    url: api.workList,
    method: 'post',
    data
  })
}
export function updateBrowse(data) {
  return request({
    url: api.updateBrowse,
    method: 'post',
    data
  })
}

export function recommend(data) {
  return request({
    url: api.recommend,
    method: 'post',
    data
  })
}

export function queryWorkRecommend(data) {
  return request({
    url: api.queryWorkRecommend,
    method: 'post',
    data
  })
}

export function queryAll(data) {
  return request({
    url: api.queryAll,
    method: 'post',
    data
  })
}

export function queryAllRecycle(data) {
  return request({
    url: api.queryAllRecycle,
    method: 'post',
    data
  })
}
export function queryTalk(data) {
  return request({
    url: api.queryTalk,
    method: 'post',
    data
  })
}
export function delTalk(data) {
  return request({
    url: api.delTalk,
    method: 'post',
    data
  })
}
export function queryTeamUser(data) {
  return request({
    url:api.queryTeamUser,
    method: 'post',
    data
  })
}
export function getDesignateList(data){
  return request({
    url:api.getDesignateList,
    method:'post',
    data
  })
}
export function updDesignateList(data){
  return request({
    url:api.updDesignateList,
    method:'post',
    data
  })
}
export function getWorkPanoCount(data) {
  return request({
    url:api.getWorkPanoCount,
    method: 'post',
    data
  })
}
export function copyWork(data) {
  return request({
    url:api.copyWork,
    method: 'post',
    data
  })
}
